import _ from 'underscore';
import l from 'app/scripts/lib/localize';
import Auth from 'app/scripts/db/auth';
import { ErrorViews } from 'app/common/data/error-views';

export const catchAllRoute = {
  routes: [['*splat', 'displayErrorPage']],

  displayErrorPage(opts) {
    const data = _.extend({ errorType: ErrorViews.NOT_FOUND }, opts, {
      url: location.pathname + location.search,
      isLoggedIn: Auth.isLoggedIn(),
    });

    // TODO: To route to Gamma, uncomment this line… ⤵
    // @navigate '/error', { trigger: true, state: data }

    // …and delete this one ⤵
    return this.errorView({ title: l('error'), data });
  },
};
